
import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CancelButton from "../buttons/CancelButton.vue";
import DangerButton from "../buttons/DangerButton.vue";
import EditFrame from "../EditFrame.vue";

@Component({
  components: {
    EditFrame,
    CancelButton,
    DangerButton,
  },
})
export default class RentalDuration extends Vue {
  @Prop()
  maxPrebookDuration!: string;

  @Prop()
  maxRentalDuration!: string;

  @Prop()
  minInterBookingDuration!: string;

  @Prop()
  capacity!: number;

  @Prop({
    default: false,
  })
  hideControls!: boolean;

  @Prop({ default: false }) editMode!: boolean;

  maxPrebookDurationD = 0;
  maxRentalDurationD = 0;
  minInterBookingDurationH = 0;

  mounted(): void {
    this.importData();
  }

  @Watch("maxPrebookDuration")
  @Watch("maxRentalDuration")
  @Watch("minInterBookingDuration")
  onDurationChanged(): void {
    this.importData();
  }

  importData(): void {
    this.maxRentalDurationD = moment.duration(this.maxRentalDuration).asDays();
    this.maxPrebookDurationD = moment
      .duration(this.maxPrebookDuration)
      .asDays();
    this.minInterBookingDurationH = moment
      .duration(this.minInterBookingDuration)
      .asHours();
  }

  onInput(): void {
    this.$emit("input", {
      maxPrebookDuration: moment
        .duration(this.maxPrebookDurationD, "days")
        .toISOString(),
      maxRentalDuration: moment
        .duration(this.maxRentalDurationD, "days")
        .toISOString(),
      minInterBookingDuration: moment
        .duration(this.minInterBookingDurationH, "hours")
        .toISOString()
    });
  }
}
